import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", immediate = false }) => {
  const target = { opacity: 1, y: 0 };
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      {...(immediate ? { animate: target } : { whileInView: target, viewport: { once: true, margin: "-80px" } })}
      transition={{ duration: 0.9, ease: EASE, delay }}
    >
      {children}
    </motion.div>
  );
};

const LINE = {
  hidden: { y: "105%" },
  show: (d) => ({ y: "0%", transition: { duration: 1.1, ease: EASE, delay: d } }),
};

export const MaskLines = ({ lines, as = "h2", className = "", delay = 0, immediate = false, label }) => {
  const Tag = motion[as];
  return (
    <Tag
      className={className}
      aria-label={label}
      initial="hidden"
      {...(immediate ? { animate: "show" } : { whileInView: "show", viewport: { once: true, amount: 0.3 } })}
    >
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.04em]" aria-hidden={label ? "true" : undefined}>
          <motion.span className="block will-change-transform" variants={LINE} custom={delay + i * 0.1}>
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

export const Eyebrow = ({ children, className = "" }) => (
  <p className={`flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.26em] text-pa-orange-text ${className}`}>
    <span className="glow-line h-px w-8 bg-pa-orange" aria-hidden="true" />
    {children}
  </p>
);
